import config from '../config/index.js';

const searchInput = document.getElementById('search-input');
const cardGrid = document.querySelector('.card-grid');
const prevBtn = document.getElementById('prev-page');
const nextBtn = document.getElementById('next-page');
const noResults = document.getElementById('no-results');

function getParams() {
  const params = new URLSearchParams(window.location.search);
  const q = params.get('q') || '';
  const page = Math.max(parseInt(params.get('page') || '1', 10), 1);
  return { q, page };
}

async function fetchCards(q = '', page = 1, perPage = 24) {
  // Align with other scripts by using config.detectionUrl
  const url = new URL('/api/search/cards', config.detectionUrl);
  if (q) url.searchParams.set('q', q);
  url.searchParams.set('page', String(page));
  url.searchParams.set('per_page', String(perPage));
  const res = await fetch(url.toString(), {
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) throw new Error('Search failed');
  return res.json();
}

function updateUrl(q, page) {
  const url = new URL(window.location.href);
  if (q) {
    url.searchParams.set('q', q);
  } else {
    url.searchParams.delete('q');
  }
  url.searchParams.set('page', String(page));
  history.pushState({}, '', url);
}

function renderResults(data) {
  cardGrid.innerHTML = '';
  if (data.hits.length === 0) {
    const trimmedQuery = q?.trim();
    if (trimmedQuery) {
      noResults.textContent = `No cards found for "${trimmedQuery}". Nobody has added that card yet.`;
    } else {
      noResults.textContent = 'No cards found yet. Nobody has added that card.';
    }
    noResults.hidden = false;
  } else {
    noResults.hidden = true;
    data.hits.forEach((card) => {
      const div = document.createElement('div');
      div.className = 'card';

      const img = document.createElement('img');
      img.src = card.image;
      img.alt = card.title;
      div.appendChild(img);

      // Header row with title (left) and profile link (right)
      const header = document.createElement('div');
      header.className = 'card-header';

      const title = document.createElement('p');
      title.className = 'card-title shrinkable';
      title.textContent = card.title;
      header.appendChild(title);

      const ownerUsername = card.owner_username || card.username;
      // Attach useful fields for the modal
      div.dataset.title = card.title || '';
      div.dataset.player = card.player || '';
      div.dataset.program = card.program || '';
      div.dataset.year = card.year || '';
      div.dataset.cardNumber = card.card_number || '';
      div.dataset.parallel = card.parallel || '';
      if (ownerUsername) div.dataset.ownerUsername = ownerUsername;
      if (ownerUsername) {
        const ownerLink = document.createElement('a');
        ownerLink.className = 'owner-profile-btn';
        ownerLink.href = `/profile.html?username=${ownerUsername}`;
        ownerLink.innerHTML = '<i class="fas fa-user"></i> <span class="owner-profile-label">See more</span>';
        ownerLink.title = `View ${ownerUsername}\'s profile`;
        header.appendChild(ownerLink);
      }

      div.appendChild(header);

      // Removed gray description (subtitle) per request

      cardGrid.appendChild(div);
    });
  }

  prevBtn.disabled = data.page <= 1;
  nextBtn.disabled = data.page * data.per_page >= data.total;
}

let { q, page } = getParams();
searchInput.value = q;

async function runSearch() {
  try {
    const data = await fetchCards(q, page);
    renderResults(data);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

let debounceTimer;
searchInput.addEventListener('input', (e) => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => {
    q = e.target.value.trim();
    page = 1;
    updateUrl(q, page);
    runSearch();
  }, 300);
});

prevBtn.addEventListener('click', () => {
  if (page > 1) {
    page -= 1;
    updateUrl(q, page);
    runSearch();
  }
});

nextBtn.addEventListener('click', () => {
  page += 1;
  updateUrl(q, page);
  runSearch();
});

window.addEventListener('popstate', () => {
  ({ q, page } = getParams());
  searchInput.value = q;
  runSearch();
});

runSearch();
